var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M71.9896 143.899C111.439 143.899 143.42 111.9 143.42 72.4271C143.42 32.9545 111.439 0.955566 71.9896 0.955566C32.5399 0.955566 0.55957 32.9545 0.55957 72.4271C0.55957 111.9 32.5399 143.899 71.9896 143.899Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.469 81.382L114.409 72.4368L71.9893 29.9922L29.5693 72.4368L38.5093 81.382L65.6594 54.2163V114.881H78.3094V54.2163L105.459 81.382H105.469Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmall);
export default __webpack_public_path__ + "static/media/arrowSmall.d0c5cd722be920c25f5d8fd9e5f98aad.svg";
export { ForwardRef as ReactComponent };